export {WModal as default} from './WModal'; 